import { headerFlagKeys } from '@giffgaff/fe-design-system-content'

import { OFF_CHROME_FLAGS } from '@/layouts/Main/ChromeFlagsContext'

import type { ChromeFlags } from '@/api/fe-common/getChromeFlags'

type Feature = { name: string; value?: unknown }

/**
 * This MFE's own server-side assignment of the chrome flags, for when fe-common's decision
 * (getChromeFlags) is unavailable. Off when CTC gave none.
 *
 * Unlike the fe-legacy-template version, this makes no CTC call of its own. _app already makes one
 * (the maintenance mode check), so the header flags are requested there and read here. A second call
 * would overwrite that call's cookies.
 */
export default function getOwnChromeFlags(features: Feature[] | undefined): ChromeFlags {
  if (!features) return OFF_CHROME_FLAGS

  const isOn = (flag: string) => {
    const value = features.find(({ name }) => name === flag)?.value

    return value === true || value === 'true'
  }

  return {
    isBrandRefresh: isOn(headerFlagKeys.brandRefresh),
    isBlackFriday: isOn(headerFlagKeys.blackFriday),
    isBlackFridayPrereg: isOn(headerFlagKeys.blackFridayPrereg),
  }
}
